import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyCIj_cBVQOAGZ7r0iwqgQ0wmQi5jkaWmdw",
  authDomain: "dumplingo.firebaseapp.com",
  projectId: "dumplingo",
  storageBucket: "dumplingo.appspot.com",
  messagingSenderId: "737425520699",
  appId: "1:737425520699:web:9d692201c2114aaa66841e",
  measurementId: "G-5ZM19DS2EY"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);